import Vue from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'
import VueGtag from "vue-gtag";
import mixpanel from 'mixpanel-browser';
import Toast, { POSITION } from "vue-toastification";


const stripe = Stripe('pk_live_51LVLuUFQYhtCQYJarZCVnWcpT8c8Qxc1lEGfszD90i1qXu26E0cF0nEJsma4d2zdcjm54BtyvrKRNTkAHWDIwfpa00QPynkbfY');

// 'pk_test_51LVLuUFQYhtCQYJavMFtIoKwbfbrfYJkoqPt4qo78Iwjl4gdy5tSCwW8UerQN64jrAqydUZawaxGMvXW4UIb4CXC00eXth7IGb'


Vue.config.productionTip = false

Vue.directive('click-outside', { 
  inserted: function (el, binding, vnode) {
    setTimeout(()=>{
      el.clickOutsideEvent = event => {
        if(!(el == event.target || el.contains(event.target))){
          binding.value(event);
        }
      };
      document.body.addEventListener('click', el.clickOutsideEvent)
      document.body.addEventListener("touchstart", el.clickOutsideEvent)
    }, 200)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
    document.body.removeEventListener("touchstart", el.clickOutsideEvent)
  },
});

Vue.use(Toast, {
  position: POSITION.BOTTOM_CENTER
});

Vue.use(VueGtag, {
  config: { id: "G-5H9Y3K9W65" }
}, router)

Vue.mixin({
  created(){
    // Get ready to record user events
    mixpanel.init('5fba71e1e57ec79831cbc10cfb208abf'); 
  },
  data() {
    return {
      mixpanel,
      stripe,
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
